(() => {
  if (!document.querySelector('.cf-home')) return;
  let queued = false;
  const update = () => {
    document.body.classList.toggle('cf-header-scrolled', document.querySelector('.cf-hero').getBoundingClientRect().top < -24);
    queued = false;
  };
  update();
  document.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }, { passive: true, capture: true });
  addEventListener('pageshow', update);
})();
(() => {
  const canvas = document.getElementById('cf-atmosphere');
  if (!canvas) return;
  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const toggle = document.querySelector('.cf-motion-toggle');
  const running = new Set();
  const pointer = { x: -1000, y: -1000, active: false };
  let w = 0, h = 0, nodes = [], frame = 0, last = 0, paused = false, tilt = null, magnet = null;
  const enabled = () => !paused && !reduced.matches && !document.hidden;
  const resize = () => {
    w = innerWidth; h = innerHeight;
    const dpr = Math.min(devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    nodes = Array.from({ length: Math.min(fine.matches ? 100 : 38, Math.max(26, Math.round(w * h / 11500))) }, () => ({x: Math.random() * w, y: Math.random() * h, vx: (Math.random() - .5) * .22, vy: (Math.random() - .5) * .22, r: .8 + Math.random() * 1.5}));
  };
  const resetSurface = target => {
    if (!target) return;
    for (const key of ['--cf-rx','--cf-ry','--cf-px','--cf-py','--cf-shine','--cf-mx','--cf-my']) target.style.removeProperty(key);
  };
  const draw = now => {
    frame = 0;
    if (!enabled()) return;
    const elapsed = now - last;
    if (elapsed < (fine.matches ? 16 : 33)) { frame = requestAnimationFrame(draw); return; }
    const dt = Math.min(elapsed / 16.667, 2); last = now;
    ctx.clearRect(0, 0, w, h);
    if (pointer.active && fine.matches) {
      const glow = ctx.createRadialGradient(pointer.x, pointer.y, 0, pointer.x, pointer.y, 240);
      glow.addColorStop(0, 'rgba(147,170,149,.16)'); glow.addColorStop(1, 'rgba(147,170,149,0)');
      ctx.fillStyle = glow; ctx.fillRect(0, 0, w, h);
    }
    nodes.forEach((p, index) => {
      if (pointer.active && fine.matches) {
        const dx = p.x - pointer.x, dy = p.y - pointer.y, distance = Math.hypot(dx, dy);
        if (distance < 170 && distance > 1) { const force = (1 - distance / 170) * .10; p.vx += dx / distance * force; p.vy += dy / distance * force; }
      }
      p.vx *= .995; p.vy *= .995;
      p.x += (p.vx + Math.sin(now * .0002 + index) * .07) * dt;
      p.y += (p.vy + Math.cos(now * .00018 + index) * .07) * dt;
      if (p.x < -10) p.x = w + 10; if (p.x > w + 10) p.x = -10;
      if (p.y < -10) p.y = h + 10; if (p.y > h + 10) p.y = -10;
      ctx.fillStyle = 'rgba(63,83,65,.52)'; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      for (let j = index + 1; j < nodes.length; j++) {
        const q = nodes[j], distance = Math.hypot(p.x - q.x, p.y - q.y);
        const near = pointer.active && Math.hypot(p.x - pointer.x, p.y - pointer.y) < 220;
        if (distance < (near ? 155 : 95)) { ctx.strokeStyle = `rgba(88,108,91,${(1 - distance / (near ? 155 : 95)) * (near ? .28 : .10)})`; ctx.lineWidth = .7; ctx.beginPath(); ctx.moveTo(p.x,p.y); ctx.lineTo(q.x,q.y); ctx.stroke(); }
      }
    });
    if (tilt && fine.matches) {
      const { element, rect } = tilt, x = (pointer.x - rect.left) / rect.width, y = (pointer.y - rect.top) / rect.height;
      element.style.setProperty('--cf-rx', `${(0.5-y)*2.2}deg`); element.style.setProperty('--cf-ry', `${(x-.5)*2.2}deg`);
      element.style.setProperty('--cf-px', `${x*100}%`); element.style.setProperty('--cf-py', `${y*100}%`); element.style.setProperty('--cf-shine', '1');
    }
    if (magnet && fine.matches) {
      const { element, rect } = magnet;
      element.style.setProperty('--cf-mx', `${Math.max(-4,Math.min(4,(pointer.x-rect.left-rect.width/2)*.08))}px`);
      element.style.setProperty('--cf-my', `${Math.max(-3,Math.min(3,(pointer.y-rect.top-rect.height/2)*.1))}px`);
    }
    frame = requestAnimationFrame(draw);
  };
  const sync = () => {
    cancelAnimationFrame(frame); frame = 0; last = performance.now();
    document.body.classList.toggle('cf-effects-paused', paused || reduced.matches);
    toggle.hidden = reduced.matches;
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.setAttribute('aria-label', paused ? toggle.dataset.play : toggle.dataset.pause);
    toggle.querySelector('[data-motion-label]').textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
    if (enabled()) frame = requestAnimationFrame(draw);
    else { ctx.clearRect(0,0,w,h); running.forEach(a => a.cancel()); resetSurface(tilt?.element); resetSurface(magnet?.element); }
  };
  const observe = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observe.unobserve(entry.target);
      if (!enabled()) return;
      const animation = entry.target.animate([{opacity:.2,translate:'0 24px',filter:'blur(3px)'},{opacity:1,translate:'0 0',filter:'blur(0px)'}], {duration:950,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});
      running.add(animation); animation.finished.then(()=>running.delete(animation),()=>running.delete(animation));
    });
  }, {threshold:.12});
  const scan = () => {
    document.querySelectorAll('.cf-card-media,.cf-collection-card-photo,.product-grid__card').forEach(element => {
      if (element.dataset.cfGlass) return; element.dataset.cfGlass = 'true'; element.classList.add('cf-tilt-surface');
      element.addEventListener('pointerenter', event => { if (enabled() && event.pointerType === 'mouse') tilt = {element,rect:element.getBoundingClientRect()}; });
      element.addEventListener('pointerleave', () => { resetSurface(element); if (tilt?.element === element) tilt = null; });
    });
    document.querySelectorAll('.cf-button,.product-form__submit').forEach(element => {
      if (element.dataset.cfMagnet) return; element.dataset.cfMagnet = 'true'; element.classList.add('cf-magnetic');
      element.addEventListener('pointerenter', event => { if (enabled() && event.pointerType === 'mouse') magnet = {element,rect:element.getBoundingClientRect()}; });
      element.addEventListener('pointerleave', () => {resetSurface(element); if(magnet?.element===element)magnet=null;});
    });
    document.querySelectorAll('.cf-collection-copy,.product-details,.crampfit-footer__column,.cf-off-copy h2,.cf-campaign-copy h2,.cf-detail-strip>div').forEach(element=>{if(!element.dataset.cfEntrance){element.dataset.cfEntrance='true';observe.observe(element);}});
  };
  document.addEventListener('pointermove', event => { pointer.x = event.clientX; pointer.y = event.clientY; pointer.active = event.pointerType === 'mouse'; }, {passive:true});
  document.addEventListener('pointerleave', () => {pointer.active=false;});
  document.addEventListener('scroll', () => {resetSurface(tilt?.element);resetSurface(magnet?.element);tilt=null;magnet=null;}, {passive:true,capture:true});
  window.addEventListener('resize', resize, {passive:true});
  document.addEventListener('visibilitychange',sync); reduced.addEventListener('change',sync);
  toggle.addEventListener('click',()=>{paused=!paused;sync();});
  document.addEventListener('shopify:section:load',scan);
  resize(); scan(); sync();
})();
